<template>
  <!-- Main Wrapper frgtrtrt -->
  <div class="main-wrapper login-body">
    <div class="login-wrapper">
      <div class="container">
        <img class="img-fluid logo-dark mb-2 logo-color" src="@/assets/img/logo2.png" alt="Logo" />
        <img class="img-fluid logo-light mb-2" src="@/assets/img/logo2-white.png" alt="Logo" />
        <div class="loginbox">
          <div class="login-right">
            <div class="login-right-wrap">
              <h1>Iniciar Sesión</h1>
              <p style="font-size: 18px; color: red; text-align: center;" v-if="passwordError !== ''">
                {{ this.passwordError }}
              </p>
              <Form @submit="onSubmit" :validation-schema="schema" :initial-values="initialValues" v-slot="{ errors }">
                <div class="input-block mb-3">
                  <label class="form-control-label">Correo</label>
                  <Field name="email" type="text" class="form-control"
                    :class="{ 'is-invalid': errors.email }" />
                  <div class="invalid-feedback">{{ errors.email }}</div>
                  <div class="emailshow text-danger" id="email"></div>
                </div>
                <div class="input-block mb-3">
                  <label class="form-control-label">Contraseña </label>
                  <div class="pass-group">
                    <Field name="password" :type="showPassword ? 'text' : 'password'"
                      class="form-control pass-input mt-2" :class="{ 'is-invalid': errors.password }" />
                    <span @click="toggleShow" class="toggle-password">
                      <i :class="{
                        'fas fa-eye': showPassword,
                        'fas fa-eye-slash': !showPassword,
                      }"></i>
                    </span>
                    <div class="invalid-feedback">{{ errors.password }}</div>
                    <div class="emailshow text-danger" id="password"></div>
                  </div>
                </div>




                <!--
                <div class="input-block mb-3">
                  <div class="row">
                    <div class="col-6">
                      <div class="form-check custom-checkbox">
                        <input type="checkbox" class="form-check-input" id="cb1" />
                        <label class="custom-control-label" for="cb1">Remember me</label>
                      </div>
                    </div>
                    <div class="col-6 text-end">
                      <router-link class="forgot-link" to="forgot-password"
                        >Forgot Password ?</router-link
                      >
                    </div>
                  </div>
                </div>
                -->
                <button class="btn btn-lg btn-primary w-100" type="submit">Iniciar Sesión</button>

                <!--
                <div class="login-or">
                  <span class="or-line"></span>
                  <span class="span-or">or</span>
                </div>
                <div class="social-login mb-3">
                  <span>Login with</span>
                  <a href="javascript:;" class="facebook"
                    ><i class="fab fa-facebook-f"></i></a
                  ><a href="javascript:;" class="google"><i class="fab fa-google"></i></a>
                </div>
                <div class="text-center dont-have">
                  Don't have an account yet?
                  <router-link to="register">Register</router-link>
                </div>
                -->
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>
<script>
import { Form, Field } from "vee-validate";
import api from '@/api';
import * as Yup from "yup";


export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      showPassword: false,
      password: null,
      emailError: "",
      passwordError: "",
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },

    async onSubmit(values) {
      this.emailError = "";
      this.passwordError = "";
      try {
        const response = await api.post('/login', {
          email: values.email,
          password: values.password
        });

        // Verificar que la respuesta tenga los datos necesarios
        if (!response || !response.data || !response.data.token) {
          throw new Error('Respuesta inválida del servidor');
        }

        const authData = {
          token: response.data.token,
          expiresAt: new Date().getTime() + (response.data.expiresIn * 1000),
          usuario: response.data.usuario
        };

        localStorage.setItem('credentials', JSON.stringify(authData));

        this.$router.push('/home');
      } catch (error) {
        console.error('Error en login:', error);

        // Manejo seguro de errores
        if (error.response && error.response.data && error.response.data.msg) {
          this.passwordError = error.response.data.msg;
        } else if (error.message) {
          this.passwordError = error.message;
        } else {
          this.passwordError = 'Error al conectar con el servidor. Por favor, verifica tu conexión.';
        }
      }
    }


  },
  setup() {
    const schema = Yup.object().shape({
      email: Yup.string().required("El Correo es requerido").email("Correo no es valido"),
      password: Yup.string()
        .min(6, "La contraseña debe tener al menos 6 caracteres")
        .required("La contraseña es requerido"),
    });
    // Modo demo: si VUE_APP_DEMO es "true" se precargan las credenciales demo
    const isDemo = String(process.env.VUE_APP_DEMO || "false").trim().toLowerCase() === "true";
    const initialValues = isDemo
      ? { email: "demo1@gmaiil.com", password: "123456" }
      : { email: "", password: "" };
    return {
      schema,
      initialValues,
    };
  },
};
</script>
